import { render, staticRenderFns } from "./DeleteAccountWarningDialog.vue?vue&type=template&id=e12bcbc6&scoped=true"
import script from "./DeleteAccountWarningDialog.vue?vue&type=script&lang=js"
export * from "./DeleteAccountWarningDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteAccountWarningDialog.vue?vue&type=style&index=0&id=e12bcbc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12bcbc6",
  null
  
)

export default component.exports